// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".call-to-action{margin-top:40px}.call-to-action__btn-row{display:flex}@media(max-width:599px){.call-to-action__btn-row{flex-direction:column;padding:0 1em}}@media(max-width:1100px){.call-to-action__btn-row{justify-content:center}}", ""]);
// Exports
module.exports = exports;
